<div mwlResizable
     ghostElementPositioning="absolute"
     [enableGhostResize]="true"
     [validateResize]="validateResize"
     (resizeEnd)="onResizeEnd($event)">
  <ng-content />
  <div class="d-flex justify-content-center">
    <div mwlResizeHandle class="resize-handle my-auto" [resizeEdges]="{bottom: true}"></div>
    @if (wasResized()) {
      <fa-icon class="ms-2 text-secondary clickable"
               [icon]="['far', 'times-circle']"
               [title]="'Reset' | messageTranslate"
               (click)="onResetClick()" />
    }
  </div>
</div>
